/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { SubcontractorChangeOrderRequestsControllerFindAllQueryResponse, SubcontractorChangeOrderRequestsControllerFindAllPathParams, SubcontractorChangeOrderRequestsControllerFindAllQueryParams, SubcontractorChangeOrderRequestsControllerFindAll401, SubcontractorChangeOrderRequestsControllerFindAll403 } from "../../models/changeOrdersController/SubcontractorChangeOrderRequestsControllerFindAll";

function getSubcontractorChangeOrderRequestsControllerFindAllUrl(id: SubcontractorChangeOrderRequestsControllerFindAllPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/potential-change-orders/${id}/subcontractor-change-order-requests` as const }  
  return res
}

/**
 * @summary List subcontractor change order requests
 * {@link /api/v1/potential-change-orders/:id/subcontractor-change-order-requests}
 */
export async function subcontractorChangeOrderRequestsControllerFindAll(id: SubcontractorChangeOrderRequestsControllerFindAllPathParams["id"], params?: SubcontractorChangeOrderRequestsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<SubcontractorChangeOrderRequestsControllerFindAllQueryResponse, ResponseErrorConfig<SubcontractorChangeOrderRequestsControllerFindAll401 | SubcontractorChangeOrderRequestsControllerFindAll403>, unknown>({ method : "GET", url : getSubcontractorChangeOrderRequestsControllerFindAllUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}